const DAYS_PER_MONTH_MAP = {
    0: 31,
    1: 28,
    2: 31,
    3: 30,
    4: 31,
    5: 30,
    6: 31,
    7: 31,
    8: 30,
    9: 31,
    10: 30,
    11: 31,
};


export const LONG_MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
];

export const SHORT_MONTH_NAMES = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];


export function isLeapYear(year) {
    return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
}


export function getFirstDayOfMonth(yearVal, monthVal) {
    const date = new Date(yearVal, monthVal, 1);
    return date.getDay();
}

export function getOneYearAgo(date) {
    const oneYearAgo = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
    return oneYearAgo;
}


export function getDaysInMonth(yearVal, monthVal) {
    let daysPerMonth = DAYS_PER_MONTH_MAP[monthVal];
    if (daysPerMonth === undefined) {
        throw new RangeError(`'monthVal' must be an integer between 0 to 11; received ${monthVal} instead`);
    }

    // account for extra day in February during Leap Years
    if (monthVal === 1 && isLeapYear(yearVal)) {
        daysPerMonth += 1;
    }
    return daysPerMonth;
}


export function isValidDate(dateString, startYear, endYear) {
    if (!dateString || typeof dateString !== 'string') return false;

    const firstSlashIndex = dateString.indexOf('/');
    const lastSlashIndex = dateString.lastIndexOf('/');

    // check there are at least two '/' characters in the date string
    if (!(firstSlashIndex !== lastSlashIndex && lastSlashIndex !== -1)) {
        return false;
    }
    // Require the length of the year to be 4 characters
    if (dateString.substr(lastSlashIndex + 1).length !== 4){
        return false;
    }
    const date = new Date(dateString);
    // Make sure a valid date was constructed
    if (date.toString() === 'Invalid Date') return false;
    // check to see if date is valid
    if (!Number.isNaN(date.getTime())) {
        // check to see date is within acceptable bounds
        const year = date.getFullYear();
        if (!startYear && !endYear) {
            // If no year range given, valid.
            return true;
        }
        if (year >= startYear && year <= endYear) {
            return true;
        }
    }
    return false;
}


export function formatDateString(date) {
    if (date === '') return date;
    const day = date.getDate();
    // Months in JS are 0 indexed, so increment
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    // Make sure day / month are in double digit formats
    const dayString = day < 10 ? `0${day}` : `${day}`;
    const monthString = month < 10 ? `0${month}` : `${month}`;
    return `${monthString}/${dayString}/${year}`;
}

export function formatUTCDateString(date) {
    if (date === '') return date;

    const day = date.getUTCDate();
    // Months in JS are 0 indexed, so increment
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    // Make sure day / month are in double digit formats
    const dayString = day < 10 ? `0${day}` : `${day}`;
    const monthString = month < 10 ? `0${month}` : `${month}`;
    return `${monthString}/${dayString}/${year}`;
}


export const formatTimeseriesDateString = date => {
    if (date === '') return date;

    const day = date.getUTCDate();
    const month = date.getUTCMonth();
    const year = date.getUTCFullYear();

    const monthString = SHORT_MONTH_NAMES[month];
    const yearString = year.toString(10).slice(-2);

    return `${monthString} ${day} '${yearString}`;
};

export const formatUTCMonthDayYear = date => {
    const year = date.getUTCFullYear();
    const month = LONG_MONTH_NAMES[date.getUTCMonth()];
    const day = date.getUTCDate();

    return `${month} ${day}, ${year}`;
}

export function formatMonthDayYear(date) {
    const year = date.getFullYear();
    const month = LONG_MONTH_NAMES[date.getMonth()];
    const day = date.getDate();

    return `${month} ${day}, ${year}`;
}


export const makeDateObj = dateString => ({
    date: isValidDate(dateString) ? new Date(dateString) : '',
});


export function isSameDateUTC(date1, date2) {
    return (
        date1.getUTCFullYear() === date2.getUTCFullYear() &&
        date1.getUTCMonth() === date2.getUTCMonth() &&
        date1.getUTCDate() === date2.getUTCDate()
    );
}